import React from 'react';
import PropTypes from 'prop-types';
import {
	Grid
} from '@material-ui/core';
import {Breadcrumbs} from "../../../components/Breadcrumbs";
import {CreateButton} from "../../../components/CreateButton";
import {useTranslation} from "react-i18next";
import {RefreshButton} from "../../../components/RefreshButton";

const Header = ({onRefresh}) => {
    const { t }  = useTranslation();

	const currentPath = [
        { 'name' : t('Parking zone groups'), 'url' : '/app/parking-zone-groups'}
    ];

	return (
		<Grid
			container
			spacing={3}
			justifyContent="space-between"
		>
            <Breadcrumbs path={currentPath} />
            <Grid item>
                <RefreshButton onClick={onRefresh} />
                <CreateButton url="/app/parking-zone-groups/new" />
            </Grid>
		</Grid>
	);
};

Header.propTypes = {
	className: PropTypes.string
};

export default Header;
